<template>
	<div style="overflow: hidden;">
		<div class="topic-main">
			<div class="topic-block">
				<div class="topic-box" v-for="(item, index) in topicList" :key="index" @click="toDetails(item.id)">
					<div class="topic-image">
						<img :src="$imgUrl + item.listImgPc" alt="">
					</div>
					<div class="topic-name">
						{{item.title}}
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getTopicList"></page>
		</div>
		<!-- <div style="width: 600px; margin: 0 auto;" v-else>
			<img src="../../../static/building.png" style="height: 100%; width: 100%;" alt="">
		</div> -->
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				topicList: [],
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_3.png'
		},
		methods: {
			getTopicList(dataList) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.topicList = dataList
				console.log(this.topicList);
			},
			toDetails(topic_id) {
				this.$router.push({
					path: '/ztsc_xqy',
					query: {
						topic_id: topic_id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.top-image {
		width: 100%;
		height: 260px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.topic-main {
		width: 1100px;
		margin: 25px auto;
		.topic-block {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.topic-box {
				width: 32%;
				margin: 5px 0.5%;
				cursor: pointer;
				img {
					width: 100%;
				}
				.topic-name {
					font-size: 13px;
					color: #264EA7;
					height: 25px;
					line-height: 25px;
					text-align: left;
				}
				.topic-time {
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 11px;
					color: #686868;
					text-align: left;
					span {
						margin-left: 20px;
					}
				}
				.topic-address {
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 11px;
					color: #686868;
					text-align: left;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/collection_essence/ztsc.vue